<template>
  <div class="scale" ref="scaleBox">
    <slot></slot>
  </div>
</template>
<script>
import gsap from "gsap";
export default {
  name: "scaleTween",
  props: {
    // expects the scroll progress
    zoom: Number
  },
  data() {
    return {
      boxDims: {},
      sunDims: {},
      scaleOrig: {},
      scale: 0,
      ticks: 0,
      tl: null,
      tweenedZoom: 0
    };
  },
  mounted() {
    // this.initsmctr();
    this.getBoxDims();
    this.getSunDims();
    this.getScaleOrig();
    this.rabbitholeTween();
  },

  beforeDestroy() {
    this.tl = null;
  },
  computed: {},
  methods: {
    // initsmctr() {
    // 	this.smctr = this.$ScrollMagic.Controller;
    // 	this.smScene = new this.$ScrollMagic.Scene({
    // 		triggerHook: 0,
    // 		triggerElement: this.$parent.$refs.startTween,
    // 		duration: "300%"
    // 	});
    // },

    getBoxDims() {
      let box = this.$refs.scaleBox;
      this.boxDims.item = box;
      this.boxDims.x = box.offsetLeft;
      this.boxDims.y = box.offsetTop;
      this.boxDims.parentW = box.parentNode.clientWidth;
      this.boxDims.parentH = box.parentNode.clientHeight;
      return this.boxDims;
    },

    getSunDims() {
      let sun = this.$children[0].$refs.sun;
      this.sunDims.item = sun;
      this.sunDims.x = sun.offsetLeft;
      this.sunDims.y = sun.offsetTop;
      this.sunDims.w = sun.clientWidth;
      this.sunDims.h = sun.clientHeight;
      this.sunDims.cw = this.sunDims.w / 2;
      this.sunDims.ch = this.sunDims.h / 2;
      this.sunDims.scaleX = this.boxDims.parentW / this.sunDims.cw;
      this.sunDims.scaleY = this.boxDims.parentH / this.sunDims.ch;
      this.sunDims.scale =
        this.sunDims.scaleX > this.sunDims.scaleY
          ? this.sunDims.scaleX
          : this.sunDims.scaleY;
      return this.sunDims;
    },
    getScaleOrig() {
      this.scaleOrig.x = this.sunDims.x - this.boxDims.x + this.sunDims.cw;
      this.scaleOrig.y = this.sunDims.y - this.boxDims.y + this.sunDims.ch;
      return this.scaleOrig;
    },
    rabbitholeTween() {
      this.tl = gsap.timeline({ paused: true });

      this.tl.set(this.boxDims.item, {
        transformOrigin: this.scaleOrig.x + "px " + this.scaleOrig.y + "px"
      });

      this.tl.to(this.boxDims.item, 30, {
        scale: this.sunDims.scale,
        ease: "Power4.easeIn"
      });
    }
  },
  watch: {
    zoom(nv, ov) {
      let timelineProg = nv * 0.01;
      // this.tl.progress(nv)
      gsap.to(this.$data, { tweenedZoom: timelineProg, ease: "linear" });
      // this.tl.progress(timelineProg)
    },
    tweenedZoom(nv) {
      this.tl.progress(nv);
    }
  }
};
</script>
<style>
.scale {
  position: absolute;
  left: 0;
  height: 100%;
  width: 100%;
  top: 0;
}
</style>
